import { useRef } from "react"
import { FormikProps } from "formik"
import { useNavigate } from "react-router"
import { MERCHANT_ADMIN_SHOPS_LIST_ROUTE, MERCHANT_ADMIN_ROUTE } from "../../../../../constants/routes"
import { StandardButton } from "../../../../../shared/components/buttons/StandardButton"
import { PageHeader } from "../../../../../shared/components/pageHeader/PageHeader"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { Page } from "../../../../../shared/components/pageHeader/PageHeaderApi"
import { CreateUpdateShopForm } from "../components/CreateUpdateShopForm"
import { useApiMutation } from "../../../../../core/api/useApiMutation"
import { SuccessDisplay } from "../../../../../core/api/errorTypes"
import { prepareInitialValues } from "../helpers/prepareInitialValues"
import {
    Breadcrumb,
    BreadcrumbLink,
    StandardBreadcrumbs,
} from "../../../../../shared/components/links/StandardBreadcrumbs"
import { useMerchant } from "../../../../merchants/merchantHooks"
import { CreateOrEditShopFormValues } from "../shopsTypes"
import { ShopsQuery, createShop } from "../shopsApi"

export function CreateShop() {
    const navigate = useNavigate()
    const { merchantId } = useMerchant()
    const formRef = useRef<FormikProps<CreateOrEditShopFormValues>>(null)

    const handleSaveClick = () => {
        formRef.current?.submitForm()
    }

    const { mutate: callCreateShop } = useApiMutation(createShop, {
        successDisplay: SuccessDisplay.SNACKBAR,
        async onSuccess(_, __, context) {
            await context.queryClient.invalidateQueries({ queryKey: [ShopsQuery.LIST] })
            navigate(MERCHANT_ADMIN_SHOPS_LIST_ROUTE)
        },
    })

    return (
        <>
            <LocalizedStrict id="merchant-shop-create-header" attrs={{ title: true }}>
                <PageHeader
                    page={Page.MERCHANT_ADMIN_SHOPS_CREATE}
                    title="Create shop"
                    rightElement={
                        <LocalizedStrict id="merchant-shop-create-button">
                            <StandardButton onClick={handleSaveClick}>Create</StandardButton>
                        </LocalizedStrict>
                    }
                >
                    <StandardBreadcrumbs>
                        <LocalizedStrict id="merchant-nav-item-home">
                            <BreadcrumbLink to={MERCHANT_ADMIN_ROUTE}>Home</BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="merchant-nav-item-shops">
                            <Breadcrumb>Shops</Breadcrumb>
                        </LocalizedStrict>
                        <LocalizedStrict id="merchant-nav-item-shops">
                            <BreadcrumbLink to={MERCHANT_ADMIN_SHOPS_LIST_ROUTE}>Shops</BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="merchant-shop-create-breadcrumb">
                            <Breadcrumb>Create shop</Breadcrumb>
                        </LocalizedStrict>
                    </StandardBreadcrumbs>
                </PageHeader>
            </LocalizedStrict>

            <CreateUpdateShopForm
                ref={formRef}
                initialValues={prepareInitialValues()}
                onSubmit={(data) => {
                    callCreateShop({
                        ...data,
                        merchant: {
                            id: merchantId,
                        },
                    })
                }}
            />
        </>
    )
}
